import useTimerange from './useTimerange';

const useAdjustedTimerange = (defaultTimerange = 'last 2 hours') => {
  return useTimerange(defaultTimerange, {
    shouldAdjustTo5MinIntervals: true,
  });
};

export default useAdjustedTimerange;
